import { Box, Stack, Button, Tooltip, Typography, Drawer, IconButton } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import { CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from '../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import { ImagePaths } from '../../../Utility/ImagePaths'
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { useHistory } from 'react-router-dom';
import { AmountFormat, CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions'
import { CurrencySymbol } from '../../../Utility/Constants'

export default function PackageConfiguration() {
    const history = useHistory();
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [packageList, setPackageList] = useState([]);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [isloader, setisloader] = useState(false);
    const [delIDs, setdelIDs] = useState([]);
    const [CheckBoxList, setCheckBoxList] = useState([]);
    const [isDelete, setisDelete] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);
    let commonDisable = CheckAccessFunc("front_office", "Settings", "Service Master Configuration", "Corporate Service Configuration", "SubTab")?.editAccess

    useEffect(() => {
        getPackageData()
    }, [])

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }
    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const getPackageData = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.NEW_PACKAGE_CONFIGURATION + `?get_type=get`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setPackageList(response.data.data || [])
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const tableView = () => {
        const grpDelete = () => {
            setisDelete(true)
        }
        const gridToolBar = () => {
            return (
                <Box>
                    <CommonGridToolBarWithFilterText isDelete={delIDs?.length > 0 } removeData={grpDelete.bind(this)} />
                </Box>
            )
        }

        const handleTableCheckbox = (id) => {
            let selectedIDs = new Set(id);
            setCheckBoxList(id)
            let selectedRows = packageList.filter((row) => selectedIDs.has(row.sno));
            let FinalData = []
            selectedRows.forEach((item) => {
                FinalData.push(item.id)
            })
            setdelIDs(FinalData)
        }

        packageList?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: 's_no', headerName: 'S.No', flex: 0.02, sortable: false,
                renderCell: (params) => (<Typography fontSize={'0.9vw'}>{params.api.getRowIndex(params.id) + 1}</Typography>)
            },
            {
                field: 'package_code', headerName: 'Package Code', flex: 0.20,
                renderCell: (params) => (params.row.package_code ? params.row.package_code?.length > 15 ?
                    <Tooltip placement="top" title={params.row.package_code}><Typography fontSize={'0.9vw'}>{params.row.package_code?.slice(0, 15) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.package_code}</Typography> : '-')
            },
            {
                field: 'package_name', headerName: 'Package Name', flex: 0.20,
                renderCell: (params) => (params.row.package_name ? params.row.package_name?.length > 15 ?
                    <Tooltip placement="top" title={params.row.package_name}><Typography fontSize={'0.9vw'}>{params.row.package_name?.slice(0, 15) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.package_name}</Typography> : '-')
            },
            {
                field: 'module_type', headerName: 'Apply To', flex: 0.25, align: 'center', headerAlign: 'center',
                renderCell: (params) => (<Box component={'div'}>{params?.row?.module_type ? params?.row?.module_type : '-'}</Box>)
            },
            {
                field: 'count', headerName: 'No of Services', flex: 0.20,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.count ? params?.row?.count : '0'}</Box>)

            },
            {
                field: 'package_amount', headerName: 'Service Charge', flex: 0.20,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.package_amount ?  AmountFormat(params?.row?.package_amount)?.replace(`${CurrencySymbol}`, "") : '0.00'}</Box>)
            },
            ...(commonDisable ? [{
                field: 'action', headerName: 'Action', flex: 0.1,
                renderCell: (params) => (
                    <Stack direction="row" alignItems="center" spacing={4}>
                        <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
                            <CommonEditButton size="1.5vw" onClick={() => { history.push("/Settings/NewService/PackageConfig/Add", { id: params.row?.id, PackName: params.row.package_name, PackCode: params.row.package_code, ModuleType: params.row.module_type, Isactive: params.row.is_active }) }} />
                        </Stack>
                    </Stack>)

            }] : [])
        ]
        return (
            <Box sx={{ height: '70vh', marginTop: '.5vw' }}>
                <DataGrid
                    checkboxSelection = {commonDisable ? true : false}
                    selectionModel={CheckBoxList}
                    onSelectionModelChange={(id) => handleTableCheckbox(id)}
                    rows={packageList}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    page={page}
                    pageSize={pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    // hideFooter
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    onPageChange={(newPage) => { setpage(newPage) }}
                    onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    getRowClassName={(params) => params.row.is_active === false ? 'gray-row' : ''}
                    sx={{
                        "& .gray-row .MuiDataGrid-cell": {
                            backgroundColor: "#e8e7e7 !important",
                            color: "black !important",
                        },
                        "& .gray-row .MuiDataGrid-cell[data-field='action'], & .gray-row:has(.MuiDataGrid-cell--checkbox)": {
                            backgroundColor: "white !important",
                            color: "black !important",
                        },
                        "& .gray-row .MuiDataGrid-cell:nth-child(1)": {
                            backgroundColor: "white !important",
                        }
                    }}
                    headerHeight={40}
                    density='compact'
                    disableSelectionOnClick
                    loading={isloader}
                />
            </Box>
        )
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const closeFilter = () => {
        setFilterOpen(false);
        setisDelete(false);
        setCheckBoxList([])
        setdelIDs([])
    }

    const deletePackage = () => {
        try {
            setisloader(true)
            RestAPIService.delete(`${Serviceurls.NEW_PACKAGE_CONFIGURATION}?delete_type=package&package_id=${delIDs || []}`, {})
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        getPackageData()
                        closeFilter();
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const renderFilterScreen = () => {
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{"Filter"}</Typography>
                    <Button onClick={() => { setFilterOpen(false) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_rts_dropdown'>
                        {/* <Autocomplete
                            size='small'
                            options={department_category}
                            value={filtervendorCategory}
                            onChange={(event, newValue) => {
                                setFilterVendorCategory(newValue)
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={'Vendor Catogory'}
                                />
                            )}
                        /> */}
                    </Box>
                </Box>
                <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small"
                        onClick={() => { }}
                        id="eMed_Config_btn">{"Clear"}</Button>
                    <Button variant='contained' size="small"
                        onClick={() => {
                            getPackageData();
                            setFilterOpen(false);
                        }}
                        id="eMed_Config_btn">{"Search"}</Button>
                </Stack>
            </Box>
        )
    }

    return (
        <Box component={'div'} sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box sx={{ display: "flex", alignItems: "flex-end", justifyContent: "flex-end" }}>
                <Button size='small' variant='contained' sx={{ textTransform: 'capitalize', width: '8vw', mt: "0.5vw", mb: "0.5vw" }} disabled = {!commonDisable} onClick={() => { history.push("/Settings/NewService/PackageConfig/Add") }}>ADD PACKAGE</Button>
            </Box>
            <Box component={'div'} sx={{ height: '70vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white' }}>
                {tableView()}
            </Box>
            <Drawer
                anchor={'right'}
                open={filterOpen}
                ModalProps={{ onBackdropClick: closeFilter }}
            >
                {renderFilterScreen()}
            </Drawer>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose}
                />
                : null}
            {isDelete ?
                <DeletePopup
                    DeletTitle={`Are you sure, Do you want to delete this item ?`}
                    DeleteNotify={"If you remove this, this could be effect in entire Configuration"}
                    deleteAlertPopupClose={closeFilter}
                    removeData={deletePackage}
                />
                : null}
        </Box>
    )
}